import { render } from "./EditMidCategory.vue?vue&type=template&id=4ede198c"
import script from "./EditMidCategory.vue?vue&type=script&lang=js"
export * from "./EditMidCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__